import UltimasVisualizacoes from '../pages/UltimasVisualizacoes/UltimasVisualizacoes';

export default [
    {
        path: '/ultimas-visualizacoes',
        component: UltimasVisualizacoes 
     }
]